angular.module('logbook')
.directive('commentList', ['$sce', '$route', '$http', '$rootScope', function($sce, $route, $http, $rootScope) {
   return {
      restrict: 'E',

      scope: {
         comments: '=',
         selectedLog: '=',
         newCommentUrl: '=',
         newCommentOwnerKey: '=',
         newCommentOwnerValue: '=',
         projection: '='
      },

      template: require('./comment-list.html'),

      link: function(scope, elem, attrs) {
         scope.$sce = $sce;
         
         scope.user = $rootScope.user;
         
         scope.saveComment = function(comment, $data) {
            if (!$data) {
               scope.deleteComment(comment);
               return;
            }
            
            return $http.patch(comment._links.self.href.replace(/\{.*\}/, ''),
               { "comment": $data }).then(function(r1) {
                  scope.getProjectedComment(r1.data._links.self.href)
                     .then(function(result) {
                        scope.comments[scope.comments.indexOf(comment)] = result.data;
                     });
               });
         }
         
         scope.deleteComment = function(comment) {
         
            $http.delete(comment._links.self.href.replace(/\{.*\}/,''))
               .then(function() {
                  scope.comments.splice(scope.comments.indexOf(comment), 1);
               } );
         };
         
         scope.newCommentText = 'placeholder';
         
         scope.getProjectedComment = function(url) {
            return $http.get(url.replace(/\{.*\}/,''), {
               params: {
                  'projection': scope.projection
               }
            });
         }
         
         scope.addNewComment = function($data) {
            if (!$data)
               return;

            var newComment = {};
            newComment[scope.newCommentOwnerKey] = scope.newCommentOwnerValue;
            newComment['comment'] = $data;
         
            return $http.post(scope.newCommentUrl, newComment).then(function(r1) {
               scope.getProjectedComment(r1.data._links.self.href)
               .then(function(result) {
                  if( !scope.comments )
                     scope.comments = [];
                  scope.comments.push(result.data);
               });
               scope.newCommentText='placeholder';
            });
         }
      }
    };
  }]);
